module.exports = __webpack_public_path__ + "static/img/portal-homepage.f6504df.png";


//////////////////
// WEBPACK FOOTER
// ./static/enrol/portal-homepage.png
// module id = yZQF
// module chunks = 170